import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Paper } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import Chip from "@mui/material/Chip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import FormControl from "@mui/material/FormControl";

export default function SearchSubtitlesResult(props) {
  const [showPics, setShowPics] = React.useState(false);
  const { recivedData, handleSubtitlesListId, movieData } = props;
  const [subtitlesLanguage, setSubtitlesLanguage] = React.useState("all");

  const getBorderRight = (lang) => {
    let boder = null;
    switch (lang) {
      case "en":
        boder = "solid #00ff22 15px";
        break;
      case "fa":
        boder = "solid red 15px";
        break;
      case "de":
        boder = "solid #e5ff00 15px";
        break;
      case "fr":
        boder = "solid #00e1ff 15px";
        break;
      case "it":
        boder = "solid #0400ff 15px";
        break;
      case "tr":
        boder = "solid #3b004d 15px";
        break;
    }
    return boder;
  };
  const add20Sub = (lang) => {
    let ids = recivedData
      .map((sub) =>
        sub.subtitlesLanguage == lang ? sub.subtitlesUploadId : false
      )
      .filter((sub) => sub);
    handleSubtitlesListId("add20", ids);
  };
  return (
    <Paper sx={{ width: "100%", textAlign: "left" }}>
      {recivedData.length > 0 ? (
        <>
          <Button
            size="small"
            sx={{ mb: 0.5 }}
            color={showPics ? "info" : "warning"}
            onClick={() => {
              setShowPics(!showPics);
            }}
            variant="contained"
            endIcon={showPics ? <VisibilityIcon /> : <VisibilityOffIcon />}
          >
            نمایش عکس
          </Button>
          <Button
            size="small"
            sx={{ mb: 0.5, mx: 0.5 }}
            color="info"
            onClick={() => {
              add20Sub("en");
            }}
            variant="contained"
            endIcon={<DoneAllIcon />}
          >
            انتخاب 20 زیرنویس انگلیسی
          </Button>
          <Button
            size="small"
            sx={{ mb: 0.5 }}
            color="info"
            onClick={() => {
              add20Sub("fa");
            }}
            variant="contained"
            endIcon={<DoneAllIcon />}
          >
            انتخاب 20 زیرنویس فارسی
          </Button>
          {recivedData.map((e, index) => (
            <Paper
              key={`sub-${index}`}
              sx={{
                display: "flex",
                mt: 0.5,
              }}
            >
              <Box>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleSubtitlesListId("addId", e.subtitlesUploadId);
                  }}
                  sx={{ mr: 1 }}
                >
                  انتخاب
                </Button>
              </Box>
              <Box sx={{ display: showPics ? "block" : "none" }}>
                <img
                  style={{ maxWidth: "50px", maxHeight: "50px" }}
                  src={e.coverUrl}
                />
              </Box>
              <Box
                sx={{
                  flexGrow: 9,
                  borderLeft: getBorderRight(e.subtitlesLanguage),
                }}
              >
                <Box>
                  <Typography sx={{ fontWeight: "bold", textAlign: "justify" }}>
                    {e.nameOfMovie}
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "justify" }}>
                  {e.subtitlesUploadId ? (
                    <Typography
                      sx={{
                        display: "inline",
                        px: 0.5,
                        textDecoration: "underline",
                      }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                      Id:{e.subtitlesUploadId}
                    </Typography>
                  ) : null}

                  {e.season ? (
                    <Typography
                      sx={{ display: "inline", px: 0.5 }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                      season: {e.season}
                    </Typography>
                  ) : null}

                  {e.episode ? (
                    <Typography
                      sx={{ display: "inline", px: 0.5 }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                      episode: {e.episode}
                    </Typography>
                  ) : null}

                  <Typography
                    sx={{ display: "inline", px: 0.5 }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    language: {languagesList[e.subtitlesLanguage]}
                  </Typography>
                  {e.type == "umlang" ? <StarIcon color="secondary" /> : null}
                  {e.type == "managerUpload" ? (
                    <StarHalfIcon color="secondary" />
                  ) : null}
                  {e["otherTags"].length > 0
                    ? e["otherTags"].map((tag, idx) => (
                        <Chip key={`tag-${idx}`} size="small" label={tag} />
                      ))
                    : null}
                </Box>
                <Divider />
              </Box>
            </Paper>
          ))}
        </>
      ) : (
        <Box>
          <Typography sx={{ textAlign: "center", fontWeight: "bold" }}>
            زیرنویسی پیدا نشد
          </Typography>
          <hr />
          <Typography>نکات جستجو:</Typography>
          <Typography>
            <strong>- جستوجو به فاصله و عبارات حساس می باشد :</strong>
            <br />: بعنوان مثال نوشته نشدن «'» در The Handmaids Tale (شکل صحیح:
            The Handmaid's Tale)
          </Typography>
          <Typography>
            <strong>- فاصله اضافی بین کلمات « » :</strong>
            <br />: بعنوان مثال گذاشتن دوفاصله در how i met__your mother (شکل
            صحیح: how i met your mother)
          </Typography>
          <Typography>
            <strong>- اشتباه تایپی:</strong>
            <br />
            بعنوان مثال نوشته نشدن (the) در : House of Dragon (شکل صحیح: House
            of the Dragon)
          </Typography>
          <Typography
            sx={{ backgroundColor: "#c4f5c4", padding: "5px", color: "black" }}
          >
            <strong>پیشنهاد:</strong>
            <br />
            1- بهتر است در ابتدا بخشی از نام فیلم را جستجو کنید و در صورت زیاد
            بودن یافته ها ، عنوان مناسب را پیدا نموده و دوباره جستجو کنید
            <br />
            2- اگر سریال است حتما نوع را به سریال تغییر داده و شماره فصل و قسمت
            را انتخاب کنید
            <br />
            بعنوان مثال برای جستجوی The Handmaid's Tale ابتدا Handmaid را میتوان
            جستجو کرد
            <br />
            یا برای how i met your mother ابتدا met را به همراه شماره فصل و قسمت
            میتوان جستجو کرد
          </Typography>
          <hr />
          <Typography>لطفا ابتدا به نکات بالا توجه کنید</Typography>
          <Typography>
            در صورت عدم نتیجه مناسب دکمه جستجو در اینترنت را فشار دهید
          </Typography>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Typography>زبان زیرنویس:</Typography>
            <FormControl sx={{ m: 1, minWidth: 80 }}>
              <select
                label="subtitleLanguage"
                name="subtitleLanguage"
                value={subtitlesLanguage}
                onChange={(e) => {
                  setSubtitlesLanguage(e.target.value);
                }}
              >
                <option autoFocus key={0} value="all">
                  انتخاب کنید
                </option>
                <option autoFocus key={1} value="English">
                  English
                </option>
                <option autoFocus key={2} value="Persian">
                  Persian
                </option>
                <option autoFocus key={3} value="German">
                  German
                </option>
                <option autoFocus key={4} value="French">
                  French
                </option>
                <option autoFocus key={5} value="Italian">
                  Italian
                </option>
                <option autoFocus key={6} value="Turkish">
                  Turkish
                </option>
              </select>
            </FormControl>
            <br />
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                if (subtitlesLanguage == "all") {
                } else {
                  window.open(
                    `https://www.google.com/search?q=download ${subtitlesLanguage} subtitle ${
                      movieData["nameOfMovie"]
                    } ${
                      movieData["season"] == ""
                        ? ""
                        : "season " + movieData["season"]
                    } ${
                      movieData["episode"] == ""
                        ? ""
                        : "episode " + movieData["episode"]
                    }`
                  );
                }
              }}
            >
              جستجو در اینترنت
            </Button>
          </Box>
          {subtitlesLanguage == "all" ? (
            <Typography style={{ color: "red" }}>
              لطفا برای جستجو در اینترنت یک زبان را انتخاب کنید
            </Typography>
          ) : null}
        </Box>
      )}
    </Paper>
  );
}

const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};
